function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesSafeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.02 12.02A3.984 3.984 0 0123 16a3.984 3.984 0 01-3.98 3.98A3.984 3.984 0 0115.04 16a3.984 3.984 0 013.98-3.98zm0 9.96A5.987 5.987 0 0025 16a5.987 5.987 0 00-5.98-5.98A5.987 5.987 0 0013.04 16a5.987 5.987 0 005.98 5.98zM28 25H5v-4.667h3v-2H5v-4.667h3v-2H5V7h23v18zm1-20H4a1 1 0 00-1 1v5.666a1 1 0 100 2v4.667a1 1 0 100 2V26a1 1 0 001 1h25a1 1 0 001-1V6a1 1 0 00-1-1z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesSafeFilled;